import { unitOfMeasurementOptions } from "../constants/analytics";

export const HEAT_MAP_REPORT_NAME = "Heat Map";
export const HEAT_MAP_STOPS_UNIT = "Stops";

const normalizeOption = (option) => {
  if (typeof option === "string") {
    const trimmed = option.trim();
    return trimmed ? { value: trimmed, label: trimmed } : null;
  }

  if (option && typeof option === "object") {
    const value =
      typeof option.value === "string"
        ? option.value.trim()
        : typeof option.label === "string"
          ? option.label.trim()
          : "";
    const label =
      typeof option.label === "string"
        ? option.label.trim()
        : typeof option.value === "string"
          ? option.value.trim()
          : "";

    if (!value || !label) return null;
    return { value, label };
  }

  return null;
};

const dedupeByValue = (options) => {
  const seen = new Set();
  const deduped = [];

  options.forEach((option) => {
    const normalized = normalizeOption(option);
    if (!normalized) return;

    const key = normalized.value.toLowerCase();
    if (seen.has(key)) return;

    seen.add(key);
    deduped.push(normalized);
  });

  return deduped;
};

export const isHeatMapDashboard = (selectedDashboard) => {
  return selectedDashboard?.name === HEAT_MAP_REPORT_NAME;
};

const getUnitFiltersFromDashboard = (selectedDashboard) => {
  if (!selectedDashboard || typeof selectedDashboard !== "object") {
    return [];
  }

  const rootFilters = Array.isArray(selectedDashboard.filters)
    ? selectedDashboard.filters
    : [];
  const sectionFilters = Array.isArray(selectedDashboard.sections)
    ? selectedDashboard.sections.flatMap((section) =>
        Array.isArray(section?.filters) ? section.filters : [],
      )
    : [];

  return [...rootFilters, ...sectionFilters].filter(
    (filter) => filter?.name === "unitOfMeasure",
  );
};

const getDashboardUnitOptions = (selectedDashboard) => {
  const unitFilters = getUnitFiltersFromDashboard(selectedDashboard);

  return unitFilters.flatMap((unitFilter) => {
    if (Array.isArray(unitFilter?.measures) && unitFilter.measures.length > 0) {
      return unitFilter.measures.map((measure) => ({
        value: measure,
        label: measure,
      }));
    }

    return Array.isArray(unitFilter?.options) ? unitFilter.options : [];
  });
};

export const getMeasurementUnitOptions = ({
  selectedDashboard,
  apiUnits = [],
}) => {
  const isHeatMap = isHeatMapDashboard(selectedDashboard);

  const baseOptions = [...unitOfMeasurementOptions];
  const dashboardOptions = getDashboardUnitOptions(selectedDashboard);
  const normalizedApiOptions = Array.isArray(apiUnits)
    ? apiUnits.map((unit) => ({ value: unit, label: unit }))
    : [];
  const heatMapOptions = isHeatMap
    ? [{ value: HEAT_MAP_STOPS_UNIT, label: HEAT_MAP_STOPS_UNIT }]
    : [];

  const merged = dedupeByValue([
    ...baseOptions,
    ...dashboardOptions,
    ...normalizedApiOptions,
    ...heatMapOptions,
  ]);

  if (!isHeatMap) {
    return merged.filter(
      (option) => option.value.toLowerCase() !== HEAT_MAP_STOPS_UNIT.toLowerCase(),
    );
  }

  return merged;
};